export default "__VITE_ASSET__53ed895e__"